"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TourEndPrompt = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var c = (0, BemBuilder_1.default)("tour-end-prompt");
var TourEndPrompt = function (_a) {
    var show = _a.show, onClose = _a.onClose;
    return (react_1.default.createElement(react_transition_group_1.Transition, { in: show, timeout: kaleidoscope_3.AnimationDuration.Long, mountOnEnter: true, unmountOnExit: true, onEnter: utils_1.forceReflow }, function (status) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c(), c(undefined, status)) },
        react_1.default.createElement("div", { className: c("rainbow-bar") },
            react_1.default.createElement(kaleidoscope_2.RainbowBar, null)),
        react_1.default.createElement(kaleidoscope_1.Panel, { className: c("panel"), theme: "dark" },
            react_1.default.createElement(kaleidoscope_1.IconButton, { className: c("close-button"), icon: react_1.default.createElement(icons_1.Close, null), size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Tertiary, onClick: onClose }),
            react_1.default.createElement("div", { className: c("content") },
                react_1.default.createElement("div", { className: c("heading") },
                    react_1.default.createElement(icons_1.Discover, { className: c("discover-icon"), size: icons_1.IconSize.Large }),
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "5", strong: true, theme: "dark" }, "Discover Qwilr")),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", theme: "dark" }, "If you get stuck or want to see what's possible with Qwilr you can find guides, docs, and support here")),
            react_1.default.createElement("div", { className: c("background") }),
            react_1.default.createElement("div", { className: c("caret") })))); }));
};
exports.TourEndPrompt = TourEndPrompt;
